import { render, staticRenderFns } from "./safesDeposits.vue?vue&type=template&id=49f12262&"
import script from "./safesDeposits.vue?vue&type=script&lang=js&"
export * from "./safesDeposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports